import { useEffect, useState } from "react";

import { decoColumns } from "./misc/deco-columns";
import useAxios from "@hooks/use-axios";
import { useParams } from "react-router-dom";
import useSearchParams from "@hooks/use-search-params";

const useHealthScores = () => {
    const { platformId } = useParams();         
    const { axiosInstance, loading, cancelAllRequests } = useAxios({
        base         : "panel",
        initialLoader: true
    });

    const { getSearchParams } = useSearchParams();
    const [data, setData] = useState({ healthScores: [], pagination: {} });
    const [queryParams, setQueryParams] = useState({});
    const [modalConfig, setModalConfig] = useState({ isOpen: false, row: {} });

    const handleModalConfig = (row = {}) => {
        setModalConfig(prev => ({ row, isOpen: !prev.isOpen }));
    };
    const getHealthScores = async () => {
        const {
            data: { healthScores },
            pagination
        } = await axiosInstance.get(`/health-scores/${platformId}`, {
            params: {
                page : getSearchParams("page"),
                limit: getSearchParams("limit")
            }
        });
        setData({
            healthScores: healthScores || [],
            pagination  : pagination || {}
        });
    };
    const handleRowActions = async (row = {}, action) => {
        if (action === "delete") {
            await axiosInstance.delete(`/health-scores/${platformId}/${row._id}`);
            getHealthScores();
            return;
        }
        handleModalConfig(row);
    };

    useEffect(() => {
        let isActive = true;
        if (isActive) {
            getHealthScores();
        }
        return () => {
            isActive = false;
            cancelAllRequests();
        };
    }, [queryParams]);

    return {
        data,
        loading,
        columns: decoColumns({ handleRowActions }),
        getHealthScores,
        setQueryParams,
        handleModalConfig,
        modalConfig,
        isOpen : modalConfig.isOpen
    };
};

export default useHealthScores;
